import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  upgradeButton: {
    backgroundColor: "#000",
    color: "#FFF",
    textTransform: "none",
    width: "154px",
    border: "none",
    borderRadius: "8px",
    padding: "8px 12px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
  },
  timerCountdown: {
    backgroundColor: "#fff",
    color: "#000000",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    display: "inline-block",
  },
  timerText: {
    margin: 0,
    fontWeight: 600,
  },
  // Popup styles
  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  blockingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  popupContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "24px 72px",
    maxWidth: "604px",
    width: "90%",
    textAlign: "center",
    position: "relative",
    [theme.breakpoints.down('sm')]: {
      padding: "16px 16px",
      width: "90%",
    },
  },
  popupHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: "16px",
  },
  popupLogo: {
    width: "187px",
    height: "64px",
    objectFit: "contain",
  },
  popupTitle: {
    fontSize: "18px",
    fontWeight: 600,
    margin: 0,
    fontFamily: "Inter",
  },
  popupSubtitle: {
    fontSize: "18px",
    color: "#000",
    fontWeight: 700,
    margin: "8px 0 24px 0",
    fontFamily: "Inter",
    [theme.breakpoints.down('sm')]: {
      fontSize: "16px",
    },
  },
  popupSubtitle2: {
    fontSize: "14px",
    color: "#C88704",
    fontFamily: "Inter",
    fontWeight: 500,
    "& img": {
      width: "14px",
      height: "14px",
      marginRight: "6px",
      marginBottom: "2px",
      verticalAlign: "middle",
    }
  },
  pricingInfo: {
    marginTop: "16px",
  },
  pricingText: {
    fontSize: "16px",
    fontWeight: 600,
    margin: "16px 0 8px 0",
    fontFamily: "Inter",
    textAlign:"left",
  },
  slashedPriceText: {
    textDecoration: "line-through",
    color: "#808080",
    marginRight: "8px",
    [theme.breakpoints.down('sm')]: {
      textAlign: "left"
    },
  },
  benefitsContainer: {
    textAlign: "left",
    marginBottom: "24px",
    color: "#808080",
  },
  benefitsTitle: {
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "16px",
    fontFamily: "Inter",
    textAlign: "center",
  },
  benefitItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "8px",
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: 600,
    textAlign:"justify"
  },
  benefitIcon: {
    color: "#4CAF50",
    marginRight: "8px",
    fontSize: "16px",
  },
  upgradeButtonLarge: {
    backgroundColor: "#FFA726",
    color: "#000",
    textTransform: "none",
    width: "100%",
    border: "none",
    borderRadius: "8px",
    padding: "12px 16px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "16px",
   
  },
  freeTrialText: {
    fontSize: "12px",
    color: "#999",
    fontFamily: "Inter",
  },
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
    color: "#999",
  },
  logoutButton:{
    fontFamily: "Inter",
    position: "absolute",
    top: "10px",
    right: "5px",
    background: "none",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "#808080",
    fontWeight: 500,
  },
  upgradeButtonContainer: {
    width: "60%",
    margin: "0 auto",
     marginBottom: "12px",
    [theme.breakpoints.down('sm')]: {
      marginBottom: "8px",
      width: "80%",
    },
  },

  statusPopupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  statusPopupContainer: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "32px 24px",
    maxWidth: "380px",
    width: "90%",
    textAlign: "center",
    position: "relative",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
  },
  statusIcon: {
    width: "80px",
    height: "80px",
    margin: "0 auto 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  statusTitle: {
    fontSize: "18px",
    fontWeight: 700,
    margin: "0 0 12px 0",
    fontFamily: "Inter",
    color: "#000",
  },
  statusMessage: {
    fontSize: "14px",
    fontWeight: 600,
    margin: "0 0 24px 0",
    fontFamily: "Inter",
    color: "#808080",
  },
  actionButton: {
    color: "#614600",
    textTransform: "none",
    width: "100%",
    border: "none",
    borderRadius: "8px",
    padding: "10px 16px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "15px",
      backgroundColor: "#FFC107",

    "&:hover": {
    backgroundColor: "#FFD05B",

    },
  },
  closeIconButton: {
    position: "absolute",
    top: "8px",
    right: "8px",
  }

}));

export default useStyles;